import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import AuthCallback from "@/pages/AuthCallback";
import PendingApproval from "@/pages/PendingApproval";
import Dashboard from "@/pages/Dashboard";
import Devotionals from "@/pages/Devotionals";
import DevotionalDetail from "@/pages/DevotionalDetail";
import PrayerPraise from "@/pages/PrayerPraise";
import ReadingPlans from "@/pages/ReadingPlans";
import Members from "@/pages/Members";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import Donate from "@/pages/Donate";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback before any routing/auth check.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/pending" element={<PendingApproval />} />

      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/devotionals" element={<Devotionals />} />
        <Route path="/devotionals/:id" element={<DevotionalDetail />} />
        <Route path="/prayer" element={<PrayerPraise />} />
        <Route path="/reading" element={<ReadingPlans />} />
        <Route path="/members" element={<ProtectedRoute adminOnly><Members /></ProtectedRoute>} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/donate" element={<Donate />} />
      </Route>

      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Admin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
